export const dateFromString = (dateString: string | number): Date =>
  new Date(
    typeof dateString === 'number' ? Number(dateString) * 1000 : dateString,
  );

export const formatInstantTo24HourTime = (
  dateString: string | number,
): string => {
  const date = dateFromString(dateString);
  const formatter = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  return formatter.format(date);
};

export const formatToMinutesSeconds = (milliseconds: number): string => {
  if (!milliseconds || milliseconds < 0) {
    return '00:00';
  }
  const formatter = new Intl.NumberFormat('en-US', {
    minimumIntegerDigits: 2,
    maximumFractionDigits: 0,
  });

  // Format time as mm:ss
  const totalMinutes = Math.floor(milliseconds / 1000 / 60);
  const seconds = Math.floor((milliseconds / 1000) % 60);
  return `${formatter.format(totalMinutes)}:${formatter.format(seconds)}`;
};

export const formatDateToDateTime = (dateString: string | number): string => {
  const date = dateFromString(dateString);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat('en-GB', options);
  return formatter.format(date);
};
